import React from 'react';
import {
  Grid,
  makeStyles,
  Typography,
  Theme,
  Tooltip,
} from '@material-ui/core';
import FilePreview from '../../assets/file_preview.png';
import { StructMapData } from 'components/struct-map/struct-map-types';
import { FileFormat } from './file-format';

const useStyles = makeStyles((theme: Theme) => ({
  tile: {
    padding: 5,
    borderRadius: 5,
    maxWidth: 130,
    minHeight: 105,
    marginRight: 15,
    marginTop: 5,
    marginBottom: 5,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },
  },
  fileName: {
    width: 120,
    height: 52,
    overflow: 'hidden',
    wordBreak: 'break-all',
    fontSize: 12,
    textAlign: 'center',
    lineHeight: 1.5,
  },
  thumbnail: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    '& > img': {
      maxWidth: '70%',
      height: '100%',
    },
    '&:hover': {
      '& > img': {
        opacity: 0.2,
      },
      '& > div': {
        opacity: 1,
      },
    },
  },
}));

interface FileGridProps {
  data: StructMapData[];
}

export const FileGrid = ({ data }: FileGridProps) => {
  const classes = useStyles();

  const handleDownload = (id?: string) => {
    if (!id) return;
    window.open(process.env.PUBLIC_URL + `/api/file/archival/${id}`, '_blank');
  };

  return (
    <Grid container>
      {data.map(({ id, label, fileRef }) => (
        <Grid
          item
          key={id}
          onClick={() => handleDownload(fileRef?.id)}
          className={classes.tile}
        >
          <div className={classes.thumbnail}>
            <img
              src={
                fileRef?.thumbnail?.id
                  ? process.env.PUBLIC_URL + `/api/file/${fileRef.thumbnail.id}`
                  : FilePreview
              }
              alt={label}
            />
            <FileFormat contentType={fileRef!.contentType} />
          </div>
          <Tooltip title={label ?? ''} placement="top">
            <Typography component="p" className={classes.fileName}>
              {label}
            </Typography>
          </Tooltip>
        </Grid>
      ))}
    </Grid>
  );
};
